import { render, staticRenderFns } from "./WsTable.vue?vue&type=template&id=44210738&"
import script from "./WsTable.vue?vue&type=script&lang=js&"
export * from "./WsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports